import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import WordNetworkPanel from "../../pages/components/puzzle/WordNetworkPanel";

const WordNetworkDialog = ({
    open,
    onClose,
    hasWordNetwork,
    wordNetworkData,
    onDeleteWord,
    onNodeSelect,
    onRefresh,
    onGenerateWordNetwork
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            fullScreen={false}
            sx={{ "& .MuiDialog-container": { cursor: "default" } }}
            PaperProps={{ sx: { cursor: "default" } }}
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Word Network
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {hasWordNetwork ? (
                    <Box sx={{
                        minHeight: 400,
                        display: 'flex',
                        flexDirection: 'column',
                        cursor: 'default'
                    }}>
                        <WordNetworkPanel
                            wordNetwork={wordNetworkData}
                            enableDelete={true}
                            onDeleteWord={onDeleteWord}
                            onNodeSelect={onNodeSelect}
                            showWordMeaning={false}
                            onRefresh={onRefresh}
                        />
                    </Box>
                ) : (
                    <Box sx={{
                        minHeight: 400,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 3
                    }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => onGenerateWordNetwork()}
                        >
                            Generate Word Network
                        </Button>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default WordNetworkDialog;
